import { asyncAction } from 'lib/actionCreators'

export const changeCandidateStatus = asyncAction('candidate/CHANGE_CANDIDATE_STATUS')
export const candidateStatus = asyncAction('candidate/CANDIDATE_STATUS')
